import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../ui/card';
import { TrendingUp, TrendingDown } from 'lucide-react';

const ACCENTS = {
  orange: 'text-orange-500 bg-orange-50',
  blue: 'text-blue-600 bg-blue-50',
  emerald: 'text-emerald-600 bg-emerald-50',
  slate: 'text-slate-700 bg-slate-100',
  violet: 'text-violet-600 bg-violet-50',
};

const TrendBadge = ({ pct, label }) => {
  if (pct === null || pct === undefined) {
    return <span className="text-xs text-slate-400">{label || 'No prior data'}</span>;
  }
  const up = pct >= 0;
  const cls = up ? 'bg-emerald-50 text-emerald-700' : 'bg-rose-50 text-rose-700';
  const Icon = up ? TrendingUp : TrendingDown;
  return (
    <span className={`inline-flex items-center gap-1 rounded-sm px-2 py-1 text-xs font-medium ${cls}`}>
      <Icon className="h-3 w-3" />
      {up ? '+' : ''}{pct}% {label && <span className="font-normal opacity-80">{label}</span>}
    </span>
  );
};

export const KpiCard = ({ label, value, icon: Icon, to, trend, accent = 'slate', action, testId }) => {
  const card = (
    <Card
      className="rounded-sm border-slate-200 shadow-sm transition-all duration-200 ease-in-out hover:-translate-y-0.5 hover:shadow-md hover:ring-2 hover:ring-orange-500/40 cursor-pointer h-full"
      data-testid={testId}
    >
      <CardContent className="p-5">
        <div className="flex items-start justify-between gap-2">
          <p className="text-sm text-slate-500 font-medium">{label}</p>
          {action ? action : (Icon && (
            <span className={`h-9 w-9 rounded-sm flex items-center justify-center ${ACCENTS[accent]}`}>
              <Icon className="h-5 w-5" strokeWidth={1.75} />
            </span>
          ))}
        </div>
        <p className="mt-3 text-2xl font-extrabold tracking-tighter text-slate-900">{value}</p>
        {trend !== undefined && (
          <div className="mt-2">
            <TrendBadge pct={trend?.pct} label={trend?.label} />
          </div>
        )}
      </CardContent>
    </Card>
  );
  return to ? <Link to={to} className="block h-full">{card}</Link> : card;
};
